import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Vehiculos from './pages/Vehiculos';
import Conductores from './pages/Conductores';
import TiposCombustible from './pages/TiposCombustible';
import OrigenesCarga from './pages/OrigenesCarga';
import Clientes from './pages/Clientes';
import Viajes from './pages/Viajes';
import Tanques from './pages/Tanques';
import Excedentes from './pages/Excedentes';
import Usuarios from './pages/Usuarios';
import CambiarPassword from './pages/CambiarPassword';
import Reportes from './pages/Reportes';

function App() {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const u = localStorage.getItem('combustible_usuario');
    if (u) {
      try {
        setUsuario(JSON.parse(u));
      } catch {
        localStorage.removeItem('combustible_usuario');
        localStorage.removeItem('combustible_token');
      }
    }
    setLoading(false);
  }, []);

  const handleLogin = (u) => setUsuario(u);

  const actualizarUsuario = (u) => {
    setUsuario(u);
    localStorage.setItem('combustible_usuario', JSON.stringify(u));
  };

  const handleLogout = () => {
    localStorage.removeItem('combustible_token');
    localStorage.removeItem('combustible_usuario');
    setUsuario(null);
  };

  if (loading) return null;

  if (!usuario) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    );
  }

  const esAdmin = usuario.rol === 'admin';
  // ¿El usuario puede ver este módulo? (según la matriz de permisos del login)
  const puede = (modulo) => {
    if (esAdmin) return true;
    const p = usuario.permisos;
    if (!p) return false;
    return !!(p[modulo] && p[modulo].ver);
  };

  // Si el usuario debe cambiar su contraseña (temporal o nueva), forzar esa pantalla
  if (usuario.debe_cambiar_password) {
    return (
      <Router>
        <Routes>
          <Route path="/cambiar-password" element={
            <CambiarPassword usuario={usuario} onLogout={handleLogout} onPasswordChanged={actualizarUsuario} forzado={true} />
          } />
          <Route path="*" element={<Navigate to="/cambiar-password" />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard usuario={usuario} onLogout={handleLogout} />} />
        <Route path="/vehiculos" element={<Vehiculos usuario={usuario} onLogout={handleLogout} />} />
        <Route path="/conductores" element={<Conductores usuario={usuario} onLogout={handleLogout} />} />
        <Route path="/tipos-combustible" element={<TiposCombustible usuario={usuario} onLogout={handleLogout} />} />
        <Route path="/origenes-carga" element={<OrigenesCarga usuario={usuario} onLogout={handleLogout} />} />
        <Route path="/clientes" element={<Clientes usuario={usuario} onLogout={handleLogout} />} />
        <Route path="/viajes" element={<Viajes usuario={usuario} onLogout={handleLogout} />} />
        <Route path="/tanques" element={<Tanques usuario={usuario} onLogout={handleLogout} />} />
        <Route path="/cambiar-password" element={<CambiarPassword usuario={usuario} onLogout={handleLogout} onPasswordChanged={actualizarUsuario} />} />
        {puede('excedentes') && <Route path="/excedentes" element={<Excedentes usuario={usuario} onLogout={handleLogout} />} />}
        {puede('reportes') && <Route path="/reportes" element={<Reportes usuario={usuario} onLogout={handleLogout} />} />}
        {puede('usuarios') && <Route path="/usuarios" element={<Usuarios usuario={usuario} onLogout={handleLogout} />} />}
        <Route path="/login" element={<Navigate to="/" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
